import React from 'react';
import { Box, CardMedia, createStyles, makeStyles } from '@material-ui/core';
import {
    ContainerMui,
    Grid,
    GridCol,
    GridRow,
    Police,
    Typography,
    Variant
} from '../../styles';
import { AppelerCaisse } from '../appelerCaisse/AppelerCaisse';

interface ErreurFonctionnelleAvecPhotoProps {
    title: string;
    descriptionChildren: React.ReactNode;
    pathImageMobile: string;
    pathImageDesktop: string;
}

const useStyles = makeStyles(() =>
    createStyles({
        imageMobile: {
            borderRadius: '1rem 1rem 0 0',
            height: '100%',
            paddingBottom: '60%',
            backgroundPosition: 'center',
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '-1rem'
        },
        imageDesktop: {
            borderRadius: '0 1rem 1rem 0',
            height: '100%',
            position: 'relative',
            backgroundPosition: '50% 12%',
            display: 'flex',
            justifyContent: 'center'
        }
    })
);

export const ErreurFonctionnelleAvecPhoto: React.FC<
    ErreurFonctionnelleAvecPhotoProps
> = ({ title, descriptionChildren, pathImageMobile, pathImageDesktop }) => {
    const classes = useStyles();

    return (
        <Grid>
            <ContainerMui hidePadding noSpacer>
                {/* image pour mobile */}
                <GridCol col="12" className="sm:dsd-d-none">
                    <CardMedia
                        className={classes.imageMobile}
                        image={pathImageMobile}
                    />
                </GridCol>
                <GridRow>
                    {/* content */}

                    <GridCol col="12" md="7" sm="7">
                        <Box padding="1rem 1rem 0rem 1.5rem">
                            <Typography
                                variant={Variant.h1}
                                police={Police.bold}
                                marginBottom={'1rem'}
                            >
                                {title}
                            </Typography>
                            <Typography
                                variant={Variant.p}
                                marginBottom={'1rem'}
                            >
                                {descriptionChildren}
                            </Typography>
                            <AppelerCaisse />
                        </Box>
                    </GridCol>

                    {/* image desktop */}
                    <GridCol
                        className="dsd-d-none sm:dsd-d-block"
                        md="5"
                        sm="5"
                    >
                        <CardMedia
                            className={classes.imageDesktop}
                            image={pathImageDesktop}
                        />
                    </GridCol>
                </GridRow>
            </ContainerMui>
        </Grid>
    );
};
